import styled from 'styled-components';

export const Wrapper = styled.div`
  margin: 0;
  padding: 0;

  width: calc(100vw - 12rem);

  p.MuiFormHelperText-root.Mui-error {
    margin-top: 0;
    margin-bottom: 0;
  }
`;
